import fetch from "lib/fetch";
import type { ThreadConversationInterface, ThreadInterface } from "types/thread";
import type { AdApplicationInterface } from "types/ad";

type ThreadResponse = { data: ThreadInterface };
type ThreadConversationResponse = { data: Array<ThreadConversationInterface> };
type ThreadOfferResponse = { data: AdApplicationInterface };
type ThreadOffersListResponse = {
    data: Array<AdApplicationInterface>;
    pager: {
        total: number;
        total_page: number;
        last_page: number;
        per_page: number;
        current_page: number;
        order?: string;
        direction?: string;
        custom?: HashMap<number | undefined>;
    };
    filters: HashMap<unknown>;
};

export const getThreadRequest = (serviceId: string, clientId: string) =>
    fetch.get<ThreadResponse>(`thread/${serviceId}/${clientId}`);

export const getThreadOffersRequest = (serviceId: string, clientId: string) =>
    fetch.get<ThreadOffersListResponse>(`thread/${serviceId}/${clientId}/offers`);

export const applyThreadOfferRequest = (serviceId: string, clientId: string, data: HashMap<unknown>) =>
    fetch.post<ThreadOfferResponse>(`thread/${serviceId}/${clientId}/offer`, data);

export const confirmThreadOfferRequest = (serviceId: string, clientId: string, data: HashMap<unknown>) =>
    fetch.post<ThreadOfferResponse>(`thread/${serviceId}/${clientId}/offer/confirm`, data);

export const refuseThreadOfferRequest = (serviceId: string, clientId: string, data: HashMap<unknown>) =>
    fetch.post<ThreadOfferResponse>(`thread/${serviceId}/${clientId}/offer/refuse`, data);

export const getAllConversationsRequest = () =>
    fetch.get<ThreadConversationResponse>("thread");

export const getArchivedConversationsRequest = () =>
    fetch.get<ThreadConversationResponse>("thread/archived");

export const showOrMaskConversationRequest = (messageId: string, data: HashMap<unknown>) =>
    fetch.post<ThreadResponse>(`thread/${messageId}`, data);

